export default __webpack_public_path__ + "static/Inter-Italic-890025e726861dba417f85c17596da95.woff";